import { HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { QuestionAttributePipe } from 'src/app/shared/pipes/question-attribute.pipe';
import { ImagePreloadDirective } from '../directives/imagePreload.directive';
import { FilterPipe } from './filter.pipe';
import { InverseQuestionAttributePipe } from './inverse-question-attribute.pipe';
import { KeysLoopPipe } from './keys-loop.pipe';
import { LoopPipe } from './loop.pipe';
import { PercentagePipe } from './percentage.pipe';
import { ProcessConfigFilterPipe } from './process-config-filter.pipe';
import { QuestionGroupAttributesPipe } from './question-group-attributes.pipe';
import { SafeUrlPipe } from './safe-url.pipe';
import { ToFixedPipe } from './to-fixed.pipe';
import { TranslationPipe } from './translation.pipe';

@NgModule({
  declarations: [
    SafeUrlPipe,
    LoopPipe,
    KeysLoopPipe,
    PercentagePipe,
    TranslationPipe,
    ImagePreloadDirective,
    QuestionGroupAttributesPipe,
    QuestionAttributePipe,
    InverseQuestionAttributePipe,
    ToFixedPipe,
    ProcessConfigFilterPipe,
    FilterPipe
  ],
  imports: [
    HttpClientModule
  ],
  exports: [
    SafeUrlPipe,
    LoopPipe,
    KeysLoopPipe,
    PercentagePipe,
    TranslationPipe,
    ImagePreloadDirective,
    QuestionGroupAttributesPipe,
    QuestionAttributePipe,
    InverseQuestionAttributePipe,
    ToFixedPipe,
    ProcessConfigFilterPipe,
    FilterPipe
  ],
  providers: [
    QuestionGroupAttributesPipe,
    QuestionAttributePipe,
    InverseQuestionAttributePipe,
    ProcessConfigFilterPipe,
    FilterPipe
  ]
})
export class PipesModule { }
